import React from 'react';
import { CHECK_IN_ROUTES } from '@/navigators/routes';
import { CheckInStackParams } from '@/navigators/types';
import { OrderCheckInComponent } from './order-check-in-component';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<CheckInStackParams, CHECK_IN_ROUTES.Base>;

export const OrderCheckInScreen: React.FC<Props> = ({ route }) => {
  const { checkInCompleted, invoiceUUID, orderUUID } = route.params;

  return (
    <OrderCheckInComponent
      checkInCompleted={checkInCompleted}
      invoiceUUID={invoiceUUID}
      orderUUID={orderUUID}
    />
  );
};
